module.exports = __webpack_public_path__ + "static/media/navigation-icon.e7b6e0b5.svg";